<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div 
        v-show="!afterProceedToPay"
        class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          v-show="false"
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadCarparkFinance" />
        
      </div>

      <AppFilter 
        v-show="!afterProceedToPay"
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        v-show="!afterProceedToPay"
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onFilterLicenseChange" />

      <div 
        v-show="afterLoadBill && !afterProceedToPay">
        Please select at least 1 bills to proceed.
      </div>
      
      <AppTable 
        v-show="!afterProceedToPay"
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-cell-click="onTableCellClick"
        v-on:table-cell-input="onTableCellInput"
        v-on:table-cell-change="onTableCellChange" >

        <input
          slot="jt-table-th-slot-_billSelected"
          ref="tableAllSelect" 
          v-model="tableAllSelected"
          v-on:change="onTableAllSelectedClick"
          type="checkbox" />

      </AppTable>

      <button 
        v-show="afterLoadBill && !afterProceedToPay"
        class="btn btn-rounded btn-info btn-block-xs-only"
        v-on:click="onProceedToPayClick">
        Proceed to Pay
      </button>

      <AppTable 
        v-show="afterProceedToPay"
        ref="pageTablePay" 
        v-bind:tableParameter="PAY_PARAM" />

      <AppForm
        v-show="afterProceedToPay"
        ref="pageFormPay" 
        v-bind:formParameter="PAYMENT_PARAM"
        v-on:form-input="onFormInput">

        <div
          slot="jt-form-slot-onlinePaymentMethod">
          <label>Online Payment Method</label>
          <br>
          <label>iPay</label>
          <div>
            <input 
              type="radio" 
              v-bind:id="`jt-form-input-onlinePaymentMethod-ipay-fpx`"
              v-bind:name="'jt-form-input-onlinePaymentMethod'">
            <label
              v-bind:for="`jt-form-input-onlinePaymentMethod-ipay-fpx`">
              FPX
            </label>
          </div>
          <div>
            <input 
              type="radio" 
              v-bind:id="`jt-form-input-onlinePaymentMethod-ipay-credit-card`"
              v-bind:name="'jt-form-input-onlinePaymentMethod'">
            <label
              v-bind:for="`jt-form-input-onlinePaymentMethod-ipay-credit-card`">
              Credit Card
            </label>
          </div>
          <label>eWallet</label>
          <div>
            <input 
              type="radio" 
              v-bind:id="`jt-form-input-onlinePaymentMethod-ipay-boost`"
              v-bind:name="'jt-form-input-onlinePaymentMethod'">
            <label
              v-bind:for="`jt-form-input-onlinePaymentMethod-ipay-boost`">
              Boost
            </label>
          </div>
        </div>

      </AppForm>

      <button 
        v-show="afterProceedToPay"
        class="btn btn-rounded btn-info btn-block-xs-only"
        v-bind="afterProceedToPayEnable ? '' : 'disabled'"
        v-on:click="onActualProceedToPayClick">
        Proceed to Pay
      </button>

      <AppIpay88 ref="ipay88" v-show="false" />

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import AppIpay88 from "@/components/App/AppIpay88";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import ChequeBankCode from "@/components/Param/ChequeBankCode"

import PageBillCollectionSelect from "@/components/Page/Collection/PageBillCollectionSelect"

var querystring = require('querystring');

const PAY_PARAM = [
  {
    key: 'createDate',
    text: 'Bill Date',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(dataItem['_dataRef'] && dataItem['_dataRef']['billingDate']) {
        let billingDate = helper.parseDateTime(dataItem['_dataRef']['billingDate']);
        if(billingDate) {
          return billingDate.format('DD/MM/YYYY');
        }
      }
      return '';
    }
  },
  {
    key: 'type',
    text: 'Bill Type',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(dataItem['type'].endsWith('INV')) {
        return 'Invoice';
      } else if(dataItem['type'].endsWith('DN')) {
        return 'Debit Note';
      } else if(dataItem['type'].endsWith('CN')) {
        return 'Credit Note';
      }

      return '';
    },
  },
  {
    key: 'billNum',
    text: 'Bill No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      let billNum = helper.plBillNum(dataItem.creditNum || dataItem.debitNum || dataItem.invoiceNum, dataItem.carparkID, dataItem['type']);
      return `<a href="billPage?invoiceID=${dataItem.id}&type=${dataItem._type}" target="_blank">${billNum}</a>`;
    },
  },
  {
    key: 'title',
    text: 'Description',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(dataItem['_dataRef'] && dataItem['_dataRef']['description']) {
        return dataItem['_dataRef']['description'];
      }

      return '';
    },
  },
  {
    key: 'price',
    text: 'Amount (RM)',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];

      let text = helper.formatMoney(dataItem[parameterItem.key]);
      if(!dataItem['jt-summary'] && dataItem['type'].endsWith('CN')) {
        text = '-' + text;
      }
      return text;
    },
  },
];

let PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_billSelected',
    text: ' ',
    table_component: PageBillCollectionSelect,
  },
  // {
  //   key: '_billSelected2',
  //   text: ' ',
  //   table_component: PageBillCollectionSelect,
  // },
];
PARAM = PARAM.concat(PAY_PARAM);
const PARAM_MAP = helper.transformParamToMap(PARAM);


const PAYMENT_PARAM = [
  {
    key: 'paymethodID',
    text: 'Payment Method',
    form_select: [],
  },
  {
    key: 'giroTransactionCode',
    text: 'Reference',
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: 'giroTransactionDate',
    text: 'Transaction Date',
    form_hide: true,
    form_datepicker: true,
    form_input_validation: [],
  },
  {
    key: 'chequeBankCode',
    text: 'Bank Code',
    form_select: [],
    form_hide: true,
    form_default:'AFFN',
    form_select: {
      data: ChequeBankCode,
      formatSelectOptionValue: (data) => data.bankCode, 
      formatSelectOptionText: (data) => data.bankName,
    },
  },
  {
    key: 'chequeNumber',
    text: 'Cheque Number',
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: 'chequeDate',
    text: 'Cheque Date',
    form_datepicker: true,
    form_hide: true,
    form_datepicker: true,
    form_input_validation: [],
  },
  {
    key: 'onlinePaymentMethod',
    text: 'Online Payment Method',
    form_hide: true,
    form_div: true,
    // form_radio: {
    //   data: [
    //     { id: -1, name: 'iPay' },
    //     { id: 1, name: 'iPay FPX' },
    //     { id: 2, name: 'iPay Bank Transfer' },
    //     { id: -2, name: 'eWallet' },
    //     { id: 0, name: 'Boost' },
    //   ],
    // },
    // form_input_attr: (formInputParameter, radioOption) => {
    //   if(radioOption['id'] < 0) {
    //     return {style:'display:none'};
    //   }
    // },
  },
  {
    key: 'staffID',
    text: 'Staff Name',
    form_select: [],
  },
  {
    key: 'staffNo',
    text: 'Staff No',
    form_input_attr: { disabled: true },
  },
]
const PAYMENT_PARAM_MAP = helper.transformParamToMap(PAYMENT_PARAM);

export default {
  name: "PageBillCollection",
  components: {
    TemplateBasic,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
    AppIpay88,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Collection' },
        { name: 'Bill' },
      ],

      PAY_PARAM,
      PARAM,
      PARAM_MAP,

      PAYMENT_PARAM,
      PAYMENT_PARAM_MAP,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageLicense: null,
      pageCustomer: null,
      pageSeason: null,
      pageCarparkFinance: null,
      pageCarparkFinanceAddress: null,
      pageCutomerAddress: null,
      pageLease: null,
      pageBill: null,

      tableAllSelected: false,

      afterLoadBill: false,
      afterProceedToPay: false,

      paymentMethodIDGiro: 0,
      paymentMethodIDCheque: 1,
      paymentMethodIDCash: 2,
      paymentMethodIDOnline: 3,

      afterProceedToPayEnable: true,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    this.$refs['pageTable'].getTableRowSpan = this.getTableRowSpan;
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    if(helper.checkRoleIsParker()) {
      this.loadCarpark();
    } else {
      this.loadStaff();
    }
  },
  methods: {
    getTableRowSpan(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      if(tableParameter[tableParameterIndex]['key'] !== '_billSelected') {
        return 1;
      }
      if(tableData[tableDataIndex]['jt-summary']) {
        return 1;
      }
      if(tableDataIndex === 0) {
        if(this.bundleIDCount[tableData[tableDataIndex]['bundleID']]) {
          return this.bundleIDCount[tableData[tableDataIndex]['bundleID']];
        }
        return 1;
      }
      if(tableData[tableDataIndex]['bundleID']) {
        if(tableData[tableDataIndex - 1]['bundleID']) {
          if(tableData[tableDataIndex]['bundleID'] !== tableData[tableDataIndex - 1]['bundleID']) {
            return this.bundleIDCount[tableData[tableDataIndex]['bundleID']];
          } else {
            return 0;
          }
        } else {
          return this.bundleIDCount[tableData[tableDataIndex]['bundleID']];
        }
      }
      return 1;
    },

    loadStaff() {
      let feedbackItem = 'staff data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            helper.inputSelectSetOption(this.PAYMENT_PARAM_MAP['staffID'], this.pageStaff = response.data);
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadPaymentMethod();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadPaymentMethod() {
      let feedbackItem = 'payment method';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/paymethods/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            helper.inputSelectSetOption(this.PAYMENT_PARAM_MAP['paymethodID'], this.pagePaymentMethod = response.data);
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.pagePaymentMethod = JSON.parse(`[{"id":0,"name":"Giro","key":"Giro"},{"id":1,"name":"Cheque","key":"Cheque"},{"id":2,"name":"Cash","key":"Cash"},{"id":3,"name":"Online","key":"Online"}]`);
          this.loadCarpark();
          // this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.loadCustomer();
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(this.pageCarpark, this.$route.query.carparkID);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      this.afterLoadBill = false;
      
      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          this.$refs['pageFeedback'].setFeedbackMessage();
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });
          this.pageLicense = response.data;
          this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);

          if(response.data && response.data.length > 0) {
            // this.loadCarparkFinance();
            // this.loadSeason();
            this.loadInvoice();
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarparkFinance() {
      let license = this.pageLicense.find(k => k.id === this.$refs['licenseFilter'].filterValue);

      let feedbackItem = 'bill info';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/finance/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageCarparkFinance = response.data[0];
          this.loadCarparkFinanceAddress();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarparkFinanceAddress() {
      let feedbackItem = 'bill detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + this.pageCarparkFinance['addressData1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageCarparkFinanceAddress = helper.parseAddress(response);
          this.loadCustomerAddress();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCustomerAddress() {
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
      let customer = this.pageCustomer.find(k => k.id === license.customerID);

      let feedbackItem = 'customer address info';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + customer['address1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageCustomerAddress = helper.parseAddress(response);
          this.loadSeason();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeason() {
      let feedbackItem = 'season info';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageSeason = response.data;
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLease() {
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));

      let feedbackItem = 'subscription info';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/licenses/' + license.id + '/lease',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageLease = response.data;
          this.loadUnpaidBill();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadInvoice() {
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));

      this.tableAllSelected = false;

      this.afterLoadBill = false;
      this.$refs['pageTable'].setTableData(this.pageBill = null);

      let feedbackItem = 'invoices';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/invoice?customerID=' + license.customerID + '&carparkID=' + license.carparkID;
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageBill = response.data;
          this.pageBill = this.pageBill.filter(k => (k.paidDate || 0)  === 0 && (k.lockDate || 0)  === 0 && (k.voidDate || 0)  === 0 && (k.usedDate || 0)  === 0);
          this.bundleIDCount = {};

          let todayBundleID = -1;
          let affectedBundleID = [];
          let today = new moment().unix();

          today = new moment();
          today = today.unix();

          this.pageBill.forEach(k => {
            k['_type'] = 'invoice';
            k['_license'] = this.$refs['licenseFilter'].filterData.find(j => helper.compareID(j.id, this.$refs['licenseFilter'].filterValue));
            k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
            k['_carparkName'] = (k['_carpark'] || {}).name;
            k['carparkID'] = this.$refs['carparkFilter'].filterValue;
            k['_billSelected'] = false

            try {
              k['_dataRef'] = JSON.parse(k['dataRef']);

              // make all bill dated before today as bundle
              if(k['billType'] === 'INV' || k['billType'] === 'DN') {
                if(k['_dataRef']['billingDate'] < today) {
                  if(!affectedBundleID.includes(k['bundleID'])) {
                    affectedBundleID.push(k['bundleID']);
                  }
                  k['bundleID'] = todayBundleID;
                }

                if(k['type'] === 'Late Payment Penalty INV') {
                  let billingDate = helper.parseDateTime(k['_dataRef']['billingDate']).startOf('month').unix()
                  if(billingDate < today) {
                    if(!affectedBundleID.includes(k['bundleID'])) {
                      affectedBundleID.push(k['bundleID']);
                    }
                    k['bundleID'] = todayBundleID;
                  }
                }
              } 
            } catch(e) {              
            }
          });

          // modify other individual bundle bill to follow those affected by before today bundle
          this.pageBill.forEach(k => {
            if(affectedBundleID.includes(k['bundleID'])) {
              k['bundleID'] = todayBundleID;
            }
          });

          // calculate each bundle row span
          this.pageBill.forEach(k => {
            if(k['bundleID']) {
              this.bundleIDCount[k['bundleID']] = this.bundleIDCount[k['bundleID']] || 0;
              this.bundleIDCount[k['bundleID']]++;
            }
          });

          this.pageBill = this.pageBill.sort((a, b) => {
            if(a['bundleID'] !== b['bundleID']) {
              return a['bundleID'] - b['bundleID'];
            } else {
              return a['createDate'] - b['createDate'];
            }
          });


          if(this.pageBill.length > 0) {
            this.afterLoadBill = true;
            this.pageBill.push({'jt-summary' : true, 'title': 'Total Selected Payable', 'total': 0});
            this.calculateBillPayable();
          }
          this.$refs['pageTable'].setTableData(this.pageBill);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    calculateBillPayable() {
      let temp = 0;
      let index = 0;
      this.pageBill.forEach(k => {
        if(k['jt-summary']) {
          return;
        }

        if(k['_billSelected']) {
          if(k['billType'] === 'CN') {
            temp -= k['price'];
          } else {
            temp += k['price'];
          }
        }
      });
      this.pageBill[this.pageBill.length - 1]['price'] = temp;
    },

    getUrl(licenseID) {
      let url = helper.SERVER_URL + '/api2';
      if(licenseID) {
        url += '/licenses/' + licenseID;
      }
      url += '/bills?hasPaid=0';

      return url;
    },

    onFilterCarparkChange(dataIndex) {
      this.$refs['pageTable'].setTableData(this.pageBill = null);
      this.$refs['licenseFilter'].setFilterData(null);
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.pageSeason = null;
      this.pageParker = null;

      this.loadInvoice();
    },
    onTableAllSelectedClick() {
      this.$nextTick(() => {
        this.pageBill.forEach(k => k['_billSelected'] = this.tableAllSelected);
        // TODO kw workaround to make checkbox reflect current
        this.$refs['pageTable'].setTableData(null);
        this.$nextTick(() => {
          this.$refs['pageTable'].setTableData(this.pageBill);
          this.$refs['pageTable'].$forceUpdate();
          this.calculateBillPayable();
        });
      });
    },

    onAddButtonClick() {
    },
    onTableDataClick(tableData, tableDataIndex) {
    },
    async onProceedToPayClick() {
      let temp = [];
      let total = 0;

      let selectedBundle = [];
      let selectedBillDateEarliest = 0;
      let selectedBillDateLatest = 0;

      for(let k of this.pageBill) {
        if(k['jt-summary']) {
          continue;
        }

        if(k['_billSelected']) {
          temp.push(k);
          if(k['billType'] === 'CN')  {
            total -= k['price'];
          } else {
            if(k['bundleID'] && !selectedBundle.includes(k['bundleID'])) {
              selectedBundle.push(k['bundleID'])
            }

            let billingDate = k['_dataRef']['billingDate'];
            if(k['type'] === 'Late Payment Penalty INV') {
              billingDate = helper.parseDateTime(billingDate).startOf('month').unix()
            }

            if(!selectedBillDateEarliest || billingDate < selectedBillDateEarliest) {
              selectedBillDateEarliest = billingDate;
            }
            if(!selectedBillDateLatest || billingDate > selectedBillDateLatest) {
              selectedBillDateLatest = billingDate;
            }

            total += k['price'];
          }
        }
      }

      for(let k of this.pageBill) {
        if(k['jt-summary']) {
          continue;
        }

        if(!k['_billSelected']) {
          if(k['billType'] !== 'CN') {
            if(selectedBundle.includes(k['bundleID'])) {
              temp.push(k);
              total += k['price'];
              continue;
            }

            let billingDate = k['_dataRef']['billingDate'];
            if(k['type'] === 'Late Payment Penalty INV') {
              billingDate = helper.parseDateTime(billingDate).startOf('month').unix()
            }

            // if(billingDate >= selectedBillDateEarliest && billingDate <= selectedBillDateLatest) {
            if(billingDate <= selectedBillDateLatest) {
              temp.push(k);
              total += k['price'];
              continue;
            }
          }
        }
      }

      if(temp.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('Please select at least one valid bill before proceed');
        return;
      }

      if(total <= 0) {
        this.$refs['pageFeedback'].setFeedbackError('Please select bill with valid amount before proceed');
        return;
      }

      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
      let feedbackItem = 'car park setting';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      let carparkSeasonSetting = await this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + license.carparkID + '/seasonSetting',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          return response.data[0];
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })

      let availablePaymentMethod = [];
      if(helper.checkRoleIsParker()) {
        if(carparkSeasonSetting.OnlinePayment) {
          availablePaymentMethod.push({id: this.paymentMethodIDOnline, name: 'Online Payment'});
        }
      } else {
        if(carparkSeasonSetting) {
          if(carparkSeasonSetting.Cash) {
            availablePaymentMethod.push({id: this.paymentMethodIDCash, name: 'Cash'});
          }
          if(carparkSeasonSetting.Cheque) {
            availablePaymentMethod.push({id: this.paymentMethodIDCheque, name: 'Cheque'});
          }
          if(carparkSeasonSetting.Giro) {
            availablePaymentMethod.push({id: this.paymentMethodIDGiro, name: 'Giro'});
          }
          if(carparkSeasonSetting.OnlinePayment) {
            availablePaymentMethod.push({id: this.paymentMethodIDOnline, name: 'Online Payment'});
          }
        } else {
          return;
        }
      }
      helper.inputSelectSetOption(this.PAYMENT_PARAM_MAP['paymethodID'], availablePaymentMethod);

      this.afterProceedToPay = true;
      this.$refs['pageFeedback'].setFeedbackError();
      temp.push({'jt-summary' : true, 'title': 'Total Amount', 'price': total});
      this.$refs['pageTablePay'].setTableData(temp);
      this.$refs['pageFormPay'].setForm(true);

      if(helper.checkRoleIsParker()) {
        this.PAYMENT_PARAM_MAP['staffID'].form_hide = true;
        this.PAYMENT_PARAM_MAP['staffNo'].form_hide = true;
        this.PAYMENT_PARAM_MAP['staffID'].form_input_validation = [];
        this.PAYMENT_PARAM_MAP['staffNo'].form_input_validation = [];
      }

      try {
          if(JSON.parse(localStorage.getItem('user')).username === 'kahwei.chuah@july.technology') {
            this.$refs['pageFormPay'].formData['paymethodID'] = this.PAYMENT_PARAM_MAP['paymethodID'].form_select[0]['id']
            this.$refs['pageFormPay'].formData['staffID'] = this.PAYMENT_PARAM_MAP['staffID'].form_select[0]['id']
          }
      } catch(e) {
      }
    },
    setInputError(key, error) {
      this.$refs['pageFormPay'].$refs['jt-form-element-' + key][0].setInputError(error);
    },
    async onActualProceedToPayClick() {
      if(!this.afterProceedToPayEnable) {
        return;
      }
      
      let formData = this.$refs['pageFormPay'].formData;

      if(this.$refs['pageFormPay'].validateForm()) {
        return;
      }

      let paymentMethod = formData['paymethodID'];
      if(paymentMethod === this.paymentMethodIDCash) {
      } else if(paymentMethod === this.paymentMethodIDCheque) {
        if(!formData['chequeBankCode']) {
          return this.setInputError('chequeBankCode', 'This field is required');
        }
        this.setInputError('chequeBankCode');

        if(!formData['chequeNumber']) {
          return this.setInputError('chequeNumber', 'This field is required');
        }
        this.setInputError('chequeNumber');

        if(!formData['chequeDate']) {
          return this.setInputError('chequeDate', 'This field is required');
        }
        this.setInputError('chequeDate');
      } else if(paymentMethod === this.paymentMethodIDGiro) {
        // if(!formData['giroTransactionCode']) {
        //   return this.setInputError('giroTransactionCode', 'This field is required');
        // }
        // this.setInputError('giroTransactionCode');

        if(!formData['giroTransactionDate']) {
          return this.setInputError('giroTransactionDate', 'This field is required');
        }
        this.setInputError('giroTransactionDate');
      }

      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
      let customer = this.pageCustomer.find(k => k.id === license.customerID);

      this.afterProceedToPayEnable = false;
      let feedbackItem = 'customer info';
      if(customer.contact1) {
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        customer['contact'] = await this.$http
          .get(
            helper.SERVER_URL + '/api2/contact/' + customer.contact1,
            helper.createAxiosConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);
            try {
              return helper.parseContact(response);
            } catch(e) {
            }
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          }) || {};
      }

      // get collection ID
      feedbackItem = 'collection ID';
      this.$refs['pageFeedback'].setFeedbackLoading('Obtaining ' + feedbackItem);
      let collectionID = await this.$http
        .get(
          helper.SERVER_URL + '/api2/invoice/collectionID',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data.collectionID;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'obtaining', feedbackItem));
        });
      if(!collectionID) {
        this.afterProceedToPayEnable = true;
        return;
      }

      // add collection
      let temp = {};
      let total = 0;
      temp['collectionID'] = collectionID;
      temp['invoices'] = [];
      feedbackItem = 'invoice status';
      let lockDate = new moment().unix();
      for(let k of this.pageBill) {
        if(k['jt-summary']) {
          continue;
        }

        if(k['_billSelected']) {
          temp['invoices'].push(k['id']);
          if(k['billType'] === 'CN') {
            total -= k['price'];
          } else {
            total += k['price'];
          }

          // this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
          // if(!await this.$http
          //   .post(
          //     helper.SERVER_URL + '/api2/invoice/' + k['id'] + '/lock',
          //     querystring.stringify({
          //       lockDate: lockDate
          //     }),
          //     helper.createAxiosConfig()
          //   )
          //   .then(response => {
          //     let resultMeta = helper.processAxiosResponse(this, response);
          //     return true;
          //   })
          //   .catch(error => {
          //     this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
          //   })
          // ) {
          //   temp['invoices'] = null;
          //   return false;
          // }
        }
      }

      total = helper.formatMoney(total)
      
      if(!temp['invoices']) {
        this.afterProceedToPayEnable = true;
        return;
      }

      temp['invoices'] = JSON.stringify(temp['invoices']);
      feedbackItem = 'bill collection';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.SERVER_URL + '/api2/collection/',
          querystring.stringify(temp),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);

          let paymentMethod = formData['paymethodID'];
          if(paymentMethod === this.paymentMethodIDOnline) {
            this.redirectiPay(collectionID, total, license, customer);
          } else {
            this.submitOtherPayment(collectionID, total, license, customer, paymentMethod, formData);
          }
        })
        .catch(error => {
          this.afterProceedToPayEnable = true;
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    async submitOtherPayment(collectionID, total, license, customer, paymentMethod, formData) {
      let url;
      if(paymentMethod === this.paymentMethodIDCash) {
        url = 'cash'
      } else if(paymentMethod === this.paymentMethodIDCheque) {
        url = 'check'
      } else if(paymentMethod === this.paymentMethodIDGiro) {
        url = 'giro'
      }

      let temp = {};
      temp['RefNo'] = collectionID;
      temp['Status'] = 1;
      temp['TransId'] = helper.uuidv4();
      temp['remark'] = helper.plPaymentRemark(license.licenseOperatorNum, license.carparkID, this.pageCarpark);
      temp['Remark'] = helper.plPaymentRemark(license.licenseOperatorNum, license.carparkID, this.pageCarpark);
      temp['amount'] = total;
      temp['Amount'] = total;
      temp['personnelID'] = formData['staffID'];
      temp['staffID'] = formData['staffID'];
      let staff = helper.inputSelectFindOption(this.PAYMENT_PARAM_MAP['staffID'], formData['staffID']) || {}
      temp['staffName'] = staff.name;
      if(paymentMethod === this.paymentMethodIDCash) {
      } else if(paymentMethod === this.paymentMethodIDCheque) {
        temp['BankCode'] = formData['chequeBankCode'];
        temp['BankName'] = (ChequeBankCode.find(k => helper.compareID(k.bankCode, formData['chequeBankCode'])) || {}).bankName || '';
        temp['ChequeNumber'] = formData['chequeNumber'];
        temp['ChequeDate'] = helper.parseDateTime(formData['chequeDate']).unix();
      } else if(paymentMethod === this.paymentMethodIDGiro) {
        temp['Code'] = formData['giroTransactionCode'];
        temp['GiroDate'] = helper.parseDateTime(formData['giroTransactionDate']).unix();
      }

      let feedbackItem = 'bill collection';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.SERVER_URL + '/api2/fund/' + url,
          querystring.stringify(temp),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data !== 'RECEIVEOK') {
            this.$refs['pageFeedback'].setFeedbackError('Payment failed. ' + response.data);
            return;
          }

          this.$refs['pageFeedback'].setFeedbackMessage('Payment successful.');
          // if(window.location.href.includes('localhost')) {
          //   return;
          // }
          setTimeout(() => {
            try {
              if(JSON.parse(localStorage.getItem('user')).username !== 'kahwei.chuah@july.technology') {
                window.open('/billOR?RefNo=' + collectionID, '_blank');
              }
            } catch(e) {
              window.open('/billOR?RefNo=' + collectionID, '_blank');
            }
            location.reload()
          }, 3000);
        })
        .catch(error => {
          this.afterProceedToPayEnable = true;
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    redirectiPay(collectionID, total, license, customer) {
      this.$refs['ipay88'].RefNo = collectionID;
      this.$refs['ipay88'].Amount = total;
      this.$refs['ipay88'].ProdDesc = 'ParkBills Monthly Season';
      this.$refs['ipay88'].Remark = helper.plPaymentRemark(license.licenseOperatorNum, license.carparkID, this.pageCarpark);

      if(customer.isCompany) {
        this.$refs['ipay88'].UserName = customer.name;
        this.$refs['ipay88'].UserEmail = customer['contact'].companyPICemail;
        this.$refs['ipay88'].UserContact = customer['contact'].companyTelephone;
      } else {
        this.$refs['ipay88'].UserName = customer.name;
        this.$refs['ipay88'].UserEmail = customer['contact'].personalEmail;
        this.$refs['ipay88'].UserContact = customer['contact'].personalPhoneMobile;
      }

      this.$refs['ipay88'].paymentSubmitClick();
    },

    displayOR() {
      // location.href = '/billCollection?carparkID=' + this.$refs['carparkFilter'].filterValue + '&licenseID=' + this.$refs['licenseFilter'].filterValue;
      let temp = this.$refs['pageTablePay'].tableData;
      let temp2 = [];
      temp.forEach(k => {
        if(k['jt-summary']) {
          return;
        }

        let lease = this.pageLease.find(j => j['applicationNum'] === k['applicationNum']);
        k['itemName'] = this.pageSeason.find(j => j.id === lease['seasonID']).name;
        temp2.push(k);
      });

      let temp3 = {};
      temp3['license'] = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
      temp3['customer'] = this.pageCustomer.find(k => k.id === temp3['license'].customerID);
      temp3['carpark'] = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue));
      temp3['carparkFinance'] = this.pageCarparkFinance;
      temp3['carparkAddress'] = this.pageCarparkFinanceAddress;
      temp3['customerAddress'] = this.pageCustomerAddress;
      temp3['bill'] = temp2;
      helper.redirect({ path: helper.WEB_URL + '/billOR', query: temp3});
    },

    onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
    },
    onTableCellInput(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      let tableItem = tableParameter[tableParameterIndex];
      let dataItem = tableData[tableDataIndex];
      if(tableItem.key === '_billSelected') {
        dataItem['_billSelected'] = !dataItem['_billSelected']

        if(dataItem['billType'] === 'CN') {
          this.$refs['pageTable'].setTableData(null);
          this.$nextTick(() => {
            this.pageBill.forEach(k => k._billSelected2 = k._billSelected);
            this.$refs['pageTable'].setTableData(this.pageBill);
            this.$refs['pageTable'].$forceUpdate();
            this.calculateBillPayable();
          });
          return;
        }

        let selectedBillingDate = dataItem['_dataRef']['billingDate']
        if(dataItem['type'] === 'Late Payment Penalty INV') {
          selectedBillingDate = helper.parseDateTime(selectedBillingDate).startOf('month').unix()
        }

        this.$nextTick(() => {
          if(dataItem['_billSelected']) {
            let lastBundleBillDate = selectedBillingDate
            this.pageBill.forEach(j => {
              if(j['bundleID'] === dataItem['bundleID']) {
                j['_billSelected'] = true;

                let currentBillingDate = j['_dataRef']['billingDate']
                if(j['type'] === 'Late Payment Penalty INV') {
                  currentBillingDate = helper.parseDateTime(currentBillingDate).startOf('month').unix()
                }

                if(currentBillingDate > lastBundleBillDate) {
                  lastBundleBillDate = currentBillingDate;
                }
              }
            });

            let bundleIDselected = [];
            this.pageBill.forEach(j => {
              if(j['jt-summary']) {
                return;
              }

              if(j['billType'] === 'CN') {
                if(j['type'] !== 'Rev Monthly Fee CN') {
                  return;
                }
              }

              if(!j['_dataRef'] || !j['_dataRef']['billingDate']) {
                return;
              }

              let invoiceBillingDate = j['_dataRef']['billingDate'];
              if(j['type'] === 'Late Payment Penalty INV') {
                invoiceBillingDate = helper.parseDateTime(invoiceBillingDate).startOf('month').unix()
              }
              if(invoiceBillingDate <= lastBundleBillDate) {
                if(!bundleIDselected.includes(j['bundleID'])) {
                  bundleIDselected.push(j['bundleID']);
                }
                j['_billSelected'] = true;
                return;
              }

              if(j['bundleID'] === dataItem['bundleID']) {
                if(!bundleIDselected.includes(j['bundleID'])) {
                  bundleIDselected.push(j['bundleID']);
                }
                j['_billSelected'] = true;
                return;
              }
            });

            this.pageBill.forEach(j => {
              if(bundleIDselected.includes(j['bundleID'])) {
                j['_billSelected'] = true;
              }
            });
          } else {
            let earliestBundleBillDate = selectedBillingDate
            this.pageBill.forEach(j => {
              if(j['bundleID'] === dataItem['bundleID']) {
                j['_billSelected'] = true;

                let currentBillingDate = j['_dataRef']['billingDate']
                if(j['type'] === 'Late Payment Penalty INV') {
                  currentBillingDate = helper.parseDateTime(currentBillingDate).startOf('month').unix()
                }

                if(currentBillingDate < earliestBundleBillDate) {
                  earliestBundleBillDate = currentBillingDate;
                }
              }
            });

            let bundleIDunselected = [];
            this.pageBill.forEach(j => {
              if(j['jt-summary']) {
                return;
              }

              if(!j['_dataRef'] || !j['_dataRef']['billingDate']) {
                return;
              }

              let invoiceBillingDate = j['_dataRef']['billingDate'];
              if(j['type'] === 'Late Payment Penalty INV') {
                invoiceBillingDate = helper.parseDateTime(invoiceBillingDate).startOf('month').unix()
              }
              if(invoiceBillingDate >= earliestBundleBillDate) {
                if(!bundleIDunselected.includes(j['bundleID'])) {
                  bundleIDunselected.push(j['bundleID']);
                }
                j['_billSelected'] = false;
                return;
              }

              if(j['bundleID'] === dataItem['bundleID']) {
                if(!bundleIDunselected.includes(j['bundleID'])) {
                  bundleIDunselected.push(j['bundleID']);
                }
                j['_billSelected'] = false;
                return;
              }
            });

            this.pageBill.forEach(j => {
              if(bundleIDunselected.includes(j['bundleID'])) {
                j['_billSelected'] = false;
              }
            });
          }

          // TODO kw workaround to make checkbox reflect current
          this.$refs['pageTable'].setTableData(null);
          this.$nextTick(() => {
            this.pageBill.forEach(k => k._billSelected2 = k._billSelected);
            this.$refs['pageTable'].setTableData(this.pageBill);
            this.$refs['pageTable'].$forceUpdate();
            this.calculateBillPayable();
          });
        });
      }
    },
    onTableCellChange(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'paymethodID') {
        let paymentMethod = formData[formParameter.key];
        if(paymentMethod === this.paymentMethodIDGiro) {
          // giro
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['onlinePaymentMethod'].form_hide = true;
          this.PAYMENT_PARAM_MAP['staffID'].form_hide = false;
          this.PAYMENT_PARAM_MAP['staffNo'].form_hide = false;
          this.PAYMENT_PARAM_MAP['staffID'].form_input_validation = null;
          this.PAYMENT_PARAM_MAP['staffNo'].form_input_validation = null;
        } else if(paymentMethod === this.paymentMethodIDCheque) {
          // cheque
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = false;
          this.PAYMENT_PARAM_MAP['onlinePaymentMethod'].form_hide = true;
          this.PAYMENT_PARAM_MAP['staffID'].form_hide = false;
          this.PAYMENT_PARAM_MAP['staffNo'].form_hide = false;
          this.PAYMENT_PARAM_MAP['staffID'].form_input_validation = null;
          this.PAYMENT_PARAM_MAP['staffNo'].form_input_validation = null;
        } else if(paymentMethod === this.paymentMethodIDOnline) { 
          // online
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['onlinePaymentMethod'].form_hide = true;
          this.PAYMENT_PARAM_MAP['staffID'].form_hide = true;
          this.PAYMENT_PARAM_MAP['staffNo'].form_hide = true;
          this.PAYMENT_PARAM_MAP['staffID'].form_input_validation = [];
          this.PAYMENT_PARAM_MAP['staffNo'].form_input_validation = [];
        } else { 
          // cash?
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['onlinePaymentMethod'].form_hide = true;
          this.PAYMENT_PARAM_MAP['staffID'].form_hide = false;
          this.PAYMENT_PARAM_MAP['staffNo'].form_hide = false;
          this.PAYMENT_PARAM_MAP['staffID'].form_input_validation = null;
          this.PAYMENT_PARAM_MAP['staffNo'].form_input_validation = null;
        }
        
        if(helper.checkRoleIsParker()) {
          this.PAYMENT_PARAM_MAP['staffID'].form_hide = true;
          this.PAYMENT_PARAM_MAP['staffNo'].form_hide = true;
          this.PAYMENT_PARAM_MAP['staffID'].form_input_validation = [];
          this.PAYMENT_PARAM_MAP['staffNo'].form_input_validation = [];
        }
      } else if(formParameter.key === 'staffID') {
        let staff = helper.inputSelectFindOption(this.PAYMENT_PARAM_MAP['staffID'], formData['staffID']) || {}
        formData['staffNo'] = staff['personnelCode'];
      }
    },

    paymentCallback(result) {
      if(result) {
        // this.submitBill();
        this.$refs['pageFeedback'].setFeedbackError('Online payment success');
      } else {
        this.$refs['pageFeedback'].setFeedbackError('Online payment cancelled');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Collection/PageBillCollection.vue